import React from "react";
import "./Comment.css";
import userphoto from "../assets/user.png"

export default function Comment({ comments }) {
  const [commit_content, setCommitContent] = React.useState()
  const [content, setContent] = React.useState([])
  const submitCommit = (e) => {
    e.preventDefault();
    setContent(...content.push(commit_content))



  }
  return (
    <div className="comments">
      <div className="comment-name">
        <h3>Kommentlar</h3>
        <span>Soni: {comments.length}</span>
      </div>
      <div className="comment">
        <div className="comment-avatar">
          <img src={`http://rtr.profedu.uz${JSON.parse(localStorage.getItem('user_data')).photo}`} alt="rasm" />
        </div>
        <div className="comment-text">
          <input type="text" onChange={(e) => setCommitContent(e.target.value)} />
        </div>
      </div>
      <div className="comment-button">
        <div className="comment-btn">
          <button type="submit" className="btn" onClick={submitCommit}>
            Yuborish
          </button>
        </div>
      </div>
      {content.map((item, index) => {
        return (
          <div className="comment-wrote" key={index}>
            <div className="comment-avatar">
              <img src={`http://rtr.profedu.uz${JSON.parse(localStorage.getItem('user_data')).photo}`} alt="rasm" />
            </div>
            <div>
              <p className="comment-avatar-name">{JSON.parse(localStorage.getItem('user_data')).username}</p>
              <p className="comment-matn">
                {item}
              </p>
              <a >Javob</a>
            </div>
          </div>

        )
      })}
      {comments.map((comment, index) => {

        return (
          <div className="comment-wrote" key={index}>
            <div className="comment-avatar">
              {comment.user.photo ? <img src={comment.user.photo} alt="rasm" /> : <img src={userphoto} alt="rasm" />}
            </div>
            <div>
              <p className="comment-avatar-name">{comment.user.first_name}</p>
              <p className="comment-matn">
                {comment.content}
              </p>
              <a>Javob</a>
            </div>
          </div>

        )
      })}
    </div>
  );
}
